import { EntityMetadataMap, EntityDataModuleConfig } from "@ngrx/data";
import { ListingHistory } from "./history/listing-history";
import { ListingMediaAudit } from "./media/media-history/listing-media-audit";
import { OpenHouse } from "./open-houses/models/OpenHouse";
import { Listing } from "./shared/interfaces/listing";
import { ListingMedia } from "./shared/interfaces/listing-media";
import { listingPermissionMetadata } from "./shared/metadata/listing-permission.metadata";
import { listingSummaryMetadata } from "./shared/metadata/listing-summary.metadata";
import { listingServiceOfferingMetadata } from "./shared/metadata/listing-service-offerings.metadata";
import { ListingAudit } from "./history/listing-audit";
import { OpenHouseAudit } from "./shared/interfaces/open-house-audit";

const entityMetadata: EntityMetadataMap = {
	ListingSummary: listingSummaryMetadata,
	ListingPermission: listingPermissionMetadata,
	ListingServiceOffering: listingServiceOfferingMetadata,
	ListingHistory: {
		selectId: (listingHistory: ListingHistory) =>
			listingHistory.listingHistorySK + "-" + listingHistory.longName,
		sortComparer: (a: ListingHistory, b: ListingHistory) =>
			b.modificationTimestampUTCDTTM.localeCompare(a.modificationTimestampUTCDTTM),
	},
	ListingAudit: {
		selectId: (listingAudit: ListingAudit) =>
			listingAudit.listingAuditSK + "-" + listingAudit.longName,
		sortComparer: (a: ListingAudit, b: ListingAudit) =>
			b.modificationTimestampUTCDTTM.localeCompare(a.modificationTimestampUTCDTTM),
	},
	Listing: {
		selectId: (listing: Listing) => listing.listingSK,
	},
	OpenHouse: {
		selectId: (openHouse: OpenHouse) => openHouse.openHouseSK,
		sortComparer: (a: OpenHouse, b: OpenHouse) =>
			String(a?.startDTTM || "").localeCompare(String(b?.startDTTM || "")),
		filterFn: (openHouses: OpenHouse[], filterPattern: OpenHouse[]) =>
			(openHouses || []).filter((oh) =>
				(filterPattern || []).some((f) => f.openHouseSK === oh.openHouseSK && !oh.deleteDTTM)
			),
	},
	OpenHouseAudit: {
		selectId: (openHouseAudit: OpenHouseAudit) => openHouseAudit.openHouseAuditSK,
		sortComparer: (a: OpenHouseAudit, b: OpenHouseAudit) =>
			b.modificationTimestampUTCDTTM.localeCompare(a.modificationTimestampUTCDTTM),
	},
	ListingMedia: {
		selectId: (listingMedia: ListingMedia) => listingMedia.listingMediaSK,
		sortComparer: (a: ListingMedia, b: ListingMedia) => a.sortOrder - b.sortOrder,
	},
	ListingMediaAudit: {
		selectId: (listingMediaAudit: ListingMediaAudit) => listingMediaAudit.listingMediaAuditSK,
		sortComparer: (a: ListingMediaAudit, b: ListingMediaAudit) =>
			b.modificationTimestampUTCDTTM.localeCompare(a.modificationTimestampUTCDTTM),
	},
};

const pluralNames = {
	ListingSummary: "ListingSummaries",
};

export const entityConfig: EntityDataModuleConfig = {
	entityMetadata,
	pluralNames,
};
